import React, { useState, useEffect, useRef } from "react";
import { ApiService, getProductTitle } from "../services";
import styled from "styled-components";
import { Search, Close, ArrowDropDown } from "@material-ui/icons";
import { useDetectOutsideClick } from "../useDetectOutsideClick";
import useDebounce from "../useDebounce";

const LI = styled.li`
  padding: 6px 8px;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: #EBAE25;
    color: #fff;
  }
`;

const Input = styled.input`
  width: 82%;
  /* min-width: 350px; */
  max-width: 450px;
  margin: 5px 0 0;
  height: 30px;
  background: transparent;
  border: 0px;
  outline: 0;
  box-shadow: none;
  color: #777;
  padding-left: 10px;
`;
export const ProductFilter = ({
  value,
  status,
  handleProductChange,
  handleBlur,
  handleFocus,
  hostId,
  placeholder,
  style,
}) => {
  const [searchWord, setSearchWord] = useState("");
  const debouncedSearchTerm = useDebounce(searchWord, 500);
  const wrapperSRef = useRef(null);
  const [showFilterList, setShowFilterList] = useDetectOutsideClick(
    wrapperSRef,
    false
  );
  const [selectedTitle, setSelectedTitle] = useState("");
  const [productsFilterList, setProducts] = useState([]);

  useEffect(() => {
    var hitUrl =
      "products?per_page=100&host_id=" +
      (hostId || "") +
      "&search=" +
      searchWord +
      "&status=" +
      (status || "");
    ApiService({ method: "GET", route: hitUrl })
      .then((response) => {
        console.log("gh" + response);
        if (response.data.status_code === 1) {
          setProducts(response.data.data.data);
          response.data.data.data.map((values) => {
            if (values.id == value) {
              setSelectedTitle(values?.custom_fields?.title);
            }
          });
          //setSelectedValue(value);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [debouncedSearchTerm, hostId]);

  return (
    <div
      ref={wrapperSRef}
      style={Object.assign(
        {},
        {
          width: "212px",
          display: "inline-block",
          marginLeft: "10px",
          verticalAlign: "middle",
          position: "relative",
        },
        style
      )}
    >
      <div
        style={{
          background: "#fff",
          border: "1px solid rgb(226, 226, 226)",
          height: "40px",
          fontSize: "0.97rem",
          color: "#555",
          boxSizing: "border-box",
          padding: "10px",
          fontWeight: "500",
        }}
        onClick={() => {
          setShowFilterList(true);
          setSearchWord("");
        }}
      >
        {selectedTitle ? (
          <span
            style={{
              width: "calc(100% - 40px)",
              display: "inline-block",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              height: "20px",
              verticalAlign: "top",
            }}
          >
            {selectedTitle}
          </span>
        ) : (
          <span style={{ color: "#555" }}>All {getProductTitle()}</span>
        )}
        <ArrowDropDown
          style={{
            float: "right",
            fontSize: "19px",
            color: "#555",
          }}
        />
        {selectedTitle ? (
          <Close
            fontSize="small"
            style={{
              float: "right",
              fontSize: "18px",
              color: "#777",
              cursor: "pointer",
            }}
            onClick={() => {
              handleProductChange();
              setSelectedTitle();
            }}
          />
        ) : (
          ""
        )}
      </div>
      {showFilterList === true ? (
        <div
          style={Object.assign(
            {},
            {
              background: "#fff",
              position: "absolute",
              zIndex: "9",
              width: "200px",
              padding: "0 5px 5px",
              border: "1px solid rgb(226, 226, 226)",
              boxSizing: "border-box",
            },
            style
          )}
        >
          <React.Fragment>
            <Input
              value={searchWord}
              onChange={(e) => setSearchWord(e.target.value)}
              onBlur={handleBlur}
              onFocus={handleFocus}
              placeholder="Search.."
            />
            <Search
              fontSize="small"
              style={{
                verticalAlign: "middle",
                fontSize: "22px",
                color: "#ccc",
              }}
            />
          </React.Fragment>
          <ul
            style={{
              listStyleType: "none",
              padding: "5px 0",
              margin: "0",
              borderTop: "1px solid #e2e2e2",
              height: "220px",
              overflow: "auto",
            }}
          >
            {productsFilterList.map((c, i) => {
              return (
                <LI
                  key={i}
                  onClick={() => {
                    setSelectedTitle(c?.custom_fields?.title);
                    setShowFilterList(false);
                    handleProductChange(c.id, c);
                  }}
                >
                  {c.title || c?.custom_fields?.title}
                </LI>
              );
            })}
          </ul>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
